export let baseUrl = 'https://padelapi.nordicwellness.se'
